'use strict';

import 'slick-carousel';

const $document = $(document);
const $body = $('body');

$('.js-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    lazyLoad: 'ondemand',
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 640,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


$('.js-slider-gallery').slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    appendArrows: $('.gallery-block__nav')
});
